export default __webpack_public_path__ + "static/media/9.14426af7.png";